import React from 'react';
import { useInput } from 'react-admin';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

function CustomDateInput(props) {
  const {
    field,
    fieldState: { error },
  } = useInput(props);

  const { sx } = props;

  const handleChange = (value) => {
    // Return the date as an ISO string to the form state
    field.onChange(value ? value.toISOString() : null);
  };

  // The value for the DatePicker must be a Date object or null
  const value = field.value ? new Date(field.value) : null;

  return (
    <DatePicker
      label={props.label || props.source}
      value={value}
      onChange={handleChange}
      slotProps={{
        textField: {
          name: field.name,
          onBlur: field.onBlur,
          variant: 'filled',
          margin: 'dense',
          error: !!error,
          helperText: error?.message,
          sx,
        },
      }}
    />
  );
}

export default CustomDateInput;
